import { computeApiBase } from './apiBase';

const API_BASE = computeApiBase();

export async function pingApi() {
  const url = `${API_BASE}/health`;
  try {
    const res = await fetch(url);
    const data = await res.json();
    return { ok: !!data.ok, detail: data.detail || data.service || 'ok', error: null };
  } catch (err) {
    return { ok: false, detail: 'offline', error: String(err) };
  }
}

export async function listModels() {
  try {
    const res = await fetch(`${API_BASE}/models`);
    const data = await res.json();
    return Array.isArray(data.models) ? data.models : [];
  } catch {
    return [];
  }
}

export async function fetchStatus(threadId = '', options = {}) {
  try {
    const tid = String(threadId || '').trim();
    const params = new URLSearchParams();
    if (tid) params.set('thread_id', tid);
    if (options && typeof options === 'object' && options.lite) params.set('lite', '1');
    const query = params.toString();
    const suffix = query ? `?${query}` : '';
    const res = await fetch(`${API_BASE}/status${suffix}`);
    const data = await res.json();
    return data;
  } catch (err) {
    return { ok: false, error: String(err) };
  }
}
